
<template lang="pug">
  button.eui-button(@click="handleClick", :class="{ 'eui-button_dense': dense, 'eui-button_icon_flipped': iconFlipped }")
    span.eui-button_text {{ text }}
    span.eui-button_icon
      slot
</template>


<script>

export default {
  name: 'eui-button',
  props: {
    text: { type: String },
    dense: { type: Boolean },
    iconFlipped: { type: Boolean },
  },
  methods: {
    handleClick() {
      this.$emit('handleClick');
    }
  }
};

</script>

<style lang="scss">
.eui-button {
  --icon-size: 16px;
  --button-color: var(--color-body);
  border: 1px solid var(--button-color);
  background: #fff;
  color: var(--button-color);
  max-width: 100%;
  padding: var(--spacing-unit) var(--spacing-unit-x2);
  border-radius: var(--spacing-unit-x2);
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;

  display: flex;
  align-items: center;


  &_icon {
    display: block;
    height: var(--icon-size);
    margin-left: var(--spacing-unit-x0_75);

    svg {
      width: var(--icon-size);
      height: var(--icon-size);
      path {
        fill: currentColor;
      }
    }
  }

  &:hover {
    --button-color: var(--color-title);
  }

  &_dense {
    --icon-size: 14px;
    padding: var(--spacing-unit-x0_5) var(--spacing-unit);
  }

  &_icon_flipped {
    svg {
      transform: scaleY(-1);
    }
  }
}

</style>
